import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import Loader from 'views/components/UI/Loader/Loader'
import { P } from 'views/components/UI/Text'

interface AddUserProgressDialogProps {
  isOpen: boolean
  progress: string
  title?: string
}

const AddUserProgressDialog = ({ isOpen, progress, title = 'Agregando usuario' }: AddUserProgressDialogProps) => (
  <Dialog
    open={isOpen}
    disableEscapeKeyDown
    aria-labelledby="add-user-progress-title"
    aria-describedby="add-user-progress-description"
    PaperProps={{ sx: { borderRadius: '20px', padding: '20px', width: 'min(100%, 420px)' } }}
  >
    <DialogTitle id="add-user-progress-title" sx={{ textAlign: 'center', fontWeight: 700 }}>
      {title}
    </DialogTitle>
    <DialogContent sx={{ textAlign: 'center' }}>
      <div aria-live="polite">
        <Loader text={progress} />
      </div>
      <P id="add-user-progress-description" margin="16px 0px 0px">
        Espera a que termine. No cierres esta página.
      </P>
    </DialogContent>
  </Dialog>
)

export default AddUserProgressDialog
